import React, { useState, useEffect, useMemo, useRef } from 'react';
import { StyleSheet, FlatList, ScrollView, useWindowDimensions, View, Platform, ActivityIndicator, } from 'react-native';
import CustomLabel from '../../../components/CustomLabel/CustomLabel';
import CustomAssessment from '../../../components/AssessmentBuilderCmponent/Assessment/CustomAssessment';
import { Card } from 'react-native-paper';
import { useTheme } from '@react-navigation/native';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from "../../../hooks/useAuthContext";
import { SafeAreaView } from 'react-native';
import CustomButton from '../../../components/CustomButton';
import { useAssessment } from '../../../hooks/useAssessment';

const ResultsSurvey = (props) => {

    //#region Const definitions and states
    const { user, clientApi, username } = useAuthContext();
    const { loadResultResponses, loadParticipants, GetRawData, GetResults, isLoading } = useAssessment();
    const { width, height } = useWindowDimensions();
    const { t } = useTranslation();
    const { colors } = useTheme()
    const styles = makeStyles(colors)
    const [showHideStatus, setShowHideStatus] = useState(true);
    const [results, setResults] = useState({});
    const [submitted, setSubmitted] = useState({});
    const [unsubmitted, setUnsubmitted] = useState({});
    const [total, setTotal] = useState({});
    const [rate, setRate] = useState({});
    const [participants, setParticipants] = useState([]);
    const [responses, setResponses] = useState([]);
    //#endregion

    //#region useEffect
    useEffect(() => {
        setSubmittedObj()
        setUnsubmittedObj()
        setTotalObj()
        setRateObj()
    }, [results]);

    useEffect(() => {
        // * No need to do anything here
    }, [width, height]);

    useEffect(() => {
        loadParticipants(props.assmUi)
            .then((respEmployee) => {
                setParticipants(respEmployee);
                loadStatus();
            })
            .catch((error) => {
                console.error(error);
            });

        loadResultResponses(clientApi, user.token, username, props.assmUi).then((resp) => {
            setResponses(resp);

        }).catch((respError) => {
            console.error(respError);
        });
    }, []);
    //#endregion

    //#region Listeners
    const sendNotifications = (emplid = '') => {
        if (emplid === '') {
            // Send All            
        }
        else {
            // Send Specific 
        }
    }
    const setSubmittedObj = () => {
        let temp = [];
        let i = 1;
        Object.keys(results).forEach(key => {
            if (key.startsWith('sub')) {
                temp[i] = results[key];
                i = i + 1;
            }
        })
        setSubmitted({ title: "Submitted", val: temp })
    };

    const setUnsubmittedObj = () => {
        let temp = [];
        let i = 1;
        Object.keys(results).forEach(key => {
            if (key.startsWith('unsub')) {
                temp[i] = results[key];
                i = i + 1;
            }
        })
        setUnsubmitted({ title: "Unsubmitted", val: temp })
    };

    const setTotalObj = () => {
        let temp1 = [];
        let temp2 = [];
        let i = 1, j = 1;
        Object.keys(results).forEach(key => {
            if (key.startsWith('unsub')) {
                temp1[i] = results[key];
                i = i + 1;
            } else if (key.startsWith('sub')) {
                temp2[j] = results[key];
                j = j + 1;
            }
        })
        for (i = 1; i <= j; i++) { temp1[i] = temp1[i] + temp2[i]; }
        setTotal({ title: "Total", val: temp1 })
    };

    const setRateObj = () => {
        let temp = [];
        let i = 1;
        Object.keys(results).forEach(key => {
            if (key.startsWith('perc')) {
                temp[i] = results[key];
                i = i + 1;
            }
        })
        setRate({ title: "Rate", val: temp })
    };

    const loadStatus = () => {
        GetResults(clientApi, user.token, username, props.assmUi)
            .then((resp) => {
                setResults(resp[0])
            })
            .catch((error) => {
                console.error(error);
            });
    };

    //#region Submitted/Usubmitted Array Draw
    const renderStatusButton = (item, setShowStatusDetails, showStatusDetails, setClickedStage, setClickedTitle) => {
        const statusBut = [];
        const statusClicked = (stage, title) => {
            setShowStatusDetails(!showStatusDetails);
            setClickedStage(stage);
            setClickedTitle(title);
        }
        const wflObj = props.workflows.find((obj) => obj.assmType === props.wfl);
        const steps = wflObj ? wflObj.numberOfSteps : 0;
        for (let i = 1; i <= steps; i++) {
            if (item?.title === "Rate") {
                statusBut.push(
                    <CustomLabel value={item?.val[i]} type="AVAILABLEUSED" />
                );
            } else if (item?.val[i] === 0) {
                statusBut.push(
                    <CustomLabel value={item?.val[i]} type="AVAILABLEUSED" />
                );
            } else {
                statusBut.push(
                    <CustomButton
                        text={item?.val[i]}
                        onPress={() => { statusClicked(i, item?.title) }}
                        type="STATUS"
                    />
                );
            }
        }

        return statusBut;
    };

    const renderStageLabel = () => {
        const stageLabel = [];
        const wflObj = props.workflows.find((obj) => obj.assmType === props.wfl);
        const steps = wflObj ? wflObj.numberOfSteps : 0;
        for (let i = 1; i <= steps; i++) {
            stageLabel.push(
                <CustomLabel value={t('common:Stage') + ' - ' + i} type="AVAILABLEUSED_SECONDARY" />
            );
        }
        return stageLabel;
    };

    // * This renders the submitted / Unsubmitted / Total and rate table 
    // * Can extend view in order to see which employees 
    const StatusListView = (item) => {
        const [showStatusDetails, setShowStatusDetails] = useState(false)
        const [clickedStage, setClickedStage] = useState(0);
        const [clickedTitle, setClickedTitle] = useState('')
        return (
            <SafeAreaView>
                <SafeAreaView style={styles.row}>
                    <CustomLabel
                        value={item?.title}
                        type='AVAILABLEUSED' />
                    <View style={styles.space}>
                        {renderStatusButton(item, setShowStatusDetails, showStatusDetails, setClickedStage, setClickedTitle).map((label, index) => (
                            <View key={index}>{label}</View>
                        ))}
                    </View>
                </SafeAreaView>
                {showStatusDetails &&
                    <SafeAreaView>
                        <SafeAreaView style={styles.line} />
                        <SafeAreaView style={styles.detailTitle} >
                            <SafeAreaView style={styles.row}>
                                <CustomLabel value={t('common:appraisee')} type='AVAILABLEUSED' />
                                <CustomLabel value={t('common:appraiser')} type='AVAILABLEUSED' />
                                {clickedTitle === 'Unsubmitted' &&
                                    <CustomButton
                                        text={t('common:sendReminder')}
                                        onPress={() => { sendNotifications() }}
                                        iconName={"send-outline"}
                                        show="REM"
                                        type="REM"
                                        textTop="0"
                                        sz={25}
                                    />
                                }
                            </SafeAreaView>
                        </SafeAreaView>
                        <SafeAreaView style={styles.line} />
                        {participants.map((part) => {
                            if (clickedTitle === 'Unsubmitted' && part.submitted === true)
                                return;
                            if (clickedTitle === 'Submitted' && part.submitted === false)
                                return;
                            return (
                                parseInt(part.stage) === clickedStage &&
                                <SafeAreaView style={styles.row}>
                                    <CustomLabel value={part.appraiserName} type='AVAILABLEUSED' />
                                    <CustomLabel value={part.appraiseeJobTitle} type='AVAILABLEUSED' />
                                    <CustomLabel value={part.appraiseeName} type='AVAILABLEUSED' />
                                    <CustomLabel value={part.appraiserJobTitle} type='AVAILABLEUSED' />
                                    <CustomButton
                                        text={t('common:sendReminder')}
                                        onPress={() => { sendNotifications(part.appraiserId) }}
                                        iconName={"send-outline"}
                                        show="REM"
                                        type="REM"
                                        textTop="0"
                                        sz={25}
                                    />
                                </SafeAreaView>
                            )

                        })}
                    </SafeAreaView>
                }
            </SafeAreaView>
        )
    }

    const renderStatus = ({ item }) => {
        return (
            <Card style={styles.cardstyle} >
                <Card.Content>
                    <StatusListView {...item} />
                </Card.Content>
            </Card>);
    };
    //#endregion

    const handleRawData = () => {
        GetRawData(props.assmUi)
            .then((resp) => {
            })
            .catch((error) => {
                console.error(error);
            });
    };
    //#endregion

    if (isLoading)
        return (
            <View style={styles.loader}>
                <ActivityIndicator animating={true} color={colors.blue} />
            </View>
        )
    return (
        <ScrollView contentContainerStyle={styles.main}>
            {/* //* helper buttons */}
            {!isLoading &&
                <View style={styles.row}>
                    <CustomButton
                        text={showHideStatus ? t('common:hideCompletionRate') : t('common:showCompletionRate')}
                        onPress={() => { setShowHideStatus(!showHideStatus) }}
                        iconName={showHideStatus ? "chevron-down-outline" : "chevron-forward-outline"}
                        show="HOME"
                        type="HOME"
                        textTop="0"
                        sz={25}
                    />
                    <CustomButton
                        text={t('common:exportRawData')}
                        onPress={() => { handleRawData() }}
                        iconName="download-outline"
                        show="HOME"
                        type="HOME"
                        textTop="0"
                        sz={25}
                    />
                    <CustomButton
                        text={t('common:performanceReview')}
                        onPress={() => { }}
                        iconName="bar-chart-outline"
                        show="HOME"
                        type="HOME"
                        textTop="0"
                        sz={25}
                    />
                </View>
            }
            {/* // * Completion status for assessment */}
            {!isLoading &&
                <FlatList
                    data={showHideStatus ? [submitted, unsubmitted, total, rate] : []}
                    renderItem={renderStatus}
                    contentContainerStyle={{ padding: 20 }}
                    onRefresh={() => loadStatus()}
                    scrollEnabled={true}
                    refreshing={isLoading}
                    ListEmptyComponent={
                        isLoading && <ActivityIndicator animating={true} color={colors.blue} />
                    }
                    ListHeaderComponent={
                        showHideStatus &&
                        <SafeAreaView style={styles.invisiblecardstyle}>
                            <SafeAreaView style={styles.row}>
                                <CustomLabel value={t('common:assessmentstatus')} type='AVAILABLEUSED' />
                                <View style={styles.space}>
                                    {renderStageLabel().map((label, index) => (
                                        <View
                                            key={index}>{label}</View>
                                    ))}
                                </View>
                            </SafeAreaView>
                        </SafeAreaView>
                    }
                    ListFooterComponent={
                        <SafeAreaView>
                            <CustomLabel
                                value={t("common:assmEmplPreview")}
                                type="MINORTITLE"
                            />
                            <FlatList
                                ListEmptyComponent={
                                    isLoading ?
                                        <ActivityIndicator animating={true} color={colors.blue} />
                                        :
                                        <CustomLabel
                                            value={t("common:nothingToPreview")}
                                            type="ASSM"
                                        />
                                }
                                data={responses}
                                contentContainerStyle={{ alignSelf: 'flex-start' }}
                                horizontal={true}
                                showsVerticalScrollIndicator={true}
                                showsHorizontalScrollIndicator={true}
                                persistentscrollbar={true}
                                pagingEnabled={true}
                                renderItem={({ item, index }) => {
                                    return (
                                        <CustomAssessment
                                            company={item?.assm_company}
                                            allAssm={responses}
                                            assm={item[item?.length - 1]}
                                            index={item?.length - 1}
                                            sectionQuestionList={item[item?.length - 1]?.sectionQuestionList}
                                            setShowResponseScreen={props.setShowResponseScreen}
                                            setShowCreateScreen={props.setShowCreateScreen}
                                            setShowCreateGroup={props.setShowCreateGroup}
                                            setShowAssessmentsAdmin={props.setShowAssessmentsAdmin}
                                            setShowMyAssessments={props.setShowMyAssessments}
                                            toView={1}
                                            response_yn={props.response}
                                            currentStage={item?.length}
                                            Stages={item?.length}
                                            isPreview={0}
                                            resultIndx={index}
                                            showDetails={true}
                                            isResult={1}
                                        />
                                    )
                                }}
                                keyExtractor={item => `${item?.id}`}
                            />
                        </SafeAreaView>
                    } />
            }

        </ScrollView >
    );
};

const makeStyles = (colors, height, width) => StyleSheet.create({
    main: {
        flex: 1,
    },
    button: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'center',
        alignSelf: "center",
        alignItems: "center",
    },
    dropDownView: {
        flex: 1,
        margin: '2%',
        alignSelf: 'center'
    },
    mainView: {
        height: (Platform.OS === 'web' ? height * 30 / 100 : '95%'),
        justifyContent: 'center'
    },
    row: {
        justifyContent: 'center',
        flexDirection: "row"
    },
    column: {
        margin: 10,
        backgroundColor: 'black',
    },
    cardstyle: {
        backgroundColor: colors.background_white,
        borderWidth: 1,
        borderColor: colors.border_card,
        borderRadius: 14,
        shadowColor: 'rgba(92, 143, 26, 1)',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.08,
        shadowRadius: 12,
        elevation: 3,
        overflow: 'hidden',
        marginVertical: 16,
    },
    line: {
        borderTopColor: colors.buttons_primary,
        borderTopWidth: StyleSheet.hairlineWidth,
        margin: 10,

    },
    invisiblecardstyle: {
        margin: '1%',
        backgroundColor: colors.background,
    },
    space: {
        flex: 1,
        flexDirection: "row",
        justifyContent: 'space-evenly',
    },
    GoBackContainer: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        paddingLeft: 30,
        paddingRight: 30,
    },
    detailTitle: {
        flex: 1,
        marginVertical: 10
    }
});
export default ResultsSurvey; 